import React from "react";
import { Box, Container, Heading, Text, VStack, SimpleGrid, Image, Link, Icon, Flex } from "@chakra-ui/react";
import { Mail } from "lucide-react";
import { useText } from "../../i18n/lang";

const TEXT = {
  en: {
    title: "Management team",
    intro: "The people who lead Travel Time every day.",
    jobs: ["General Manager", "Managing Partner", "Agency Manager"],
  },
  ro: {
    title: "Echipa de management",
    intro: "Oamenii care conduc Travel Time în fiecare zi.",
    jobs: ["Director General", "Managing Partner", "Manager de agenție"],
  },
};

const TEAM = [
  { name: "Andrei Ștefan", email: "andrei.stefan@traveltime.ro", photo: "/images/team/small/AndreiS.webp" },
  { name: "Gabriel Mandache", email: "gabi.mandache@traveltime.ro", photo: "/images/team/small/Gabi.webp" },
  { name: "Corina Miulescu", email: "corina.miulescu@traveltime.ro", photo: "/images/team/small/Corina.webp" },
];

const HomeTeam = () => {
  const t = useText(TEXT);

  return (
    <Box py={{ base: 16, md: 24 }}>
      <Container maxW="container.lg">
        <VStack spacing={4} textAlign="center" mb={{ base: 10, md: 14 }}>
          <Heading as="h2" fontFamily="Montserrat" fontWeight="700" fontSize={{ base: "2xl", md: "4xl" }} color="gray.800">
            {t.title}
          </Heading>
          <Text fontSize={{ base: "md", md: "lg" }} color="gray.600">
            {t.intro}
          </Text>
        </VStack>

        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={6}>
          {TEAM.map((member, index) => (
            <VStack
              key={member.email}
              spacing={0}
              bg="white"
              borderRadius="2xl"
              borderWidth="1px"
              borderColor="gray.100"
              boxShadow="0 10px 30px -18px rgba(15, 40, 80, 0.35)"
              px={6}
              py={8}
              textAlign="center"
              transition="all 0.2s"
              _hover={{ transform: "translateY(-4px)", boxShadow: "0 18px 40px -18px rgba(15, 40, 80, 0.45)" }}
            >
              <Flex w="120px" h="120px" borderRadius="full" bg="blue.50" p="6px" mb={5}>
                <Image
                  src={member.photo}
                  alt={member.name}
                  htmlWidth={240}
                  htmlHeight={240}
                  w="full"
                  h="full"
                  borderRadius="full"
                  objectFit="cover"
                  loading="lazy"
                />
              </Flex>
              <Text as="h3" fontFamily="Montserrat" fontWeight="700" fontSize="xl" color="gray.800" mb={1}>
                {member.name}
              </Text>
              <Text fontSize="sm" fontWeight="700" textTransform="uppercase" letterSpacing="wider" color="blue.600" mb={4}>
                {t.jobs[index]}
              </Text>
              <Link
                href={`mailto:${member.email}`}
                display="inline-flex"
                alignItems="center"
                gap={2}
                color="gray.700"
                fontSize="sm"
                _hover={{ color: "blue.600", textDecoration: "none" }}
              >
                <Icon as={Mail} boxSize={4} color="blue.600" />
                {member.email}
              </Link>
            </VStack>
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  );
};

export default HomeTeam;
